'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderChildren(props) {
  return _react2.default.Children.map(props.children, function (child) {
    if (child.type === _.Tab) {
      return _react2.default.cloneElement(child, {
        small: props.small,
        selected: props.selected === child.key
      });
    }
    return child;
  });
}

var Tabs = function Tabs(props) {
  return _react2.default.createElement(
    'ul',
    { className: 'Tabs' },
    renderChildren(props)
  );
};

Tabs.propTypes = {
  children: _propTypes2.default.node,
  selected: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  small: _propTypes2.default.bool
};

exports.default = Tabs;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Tabs.js
// module id = 289
// module chunks = 0